import React, { Component } from 'react';
import PropTypes from 'prop-types';

// styles
import styles from './PdpRespPrintHeader.scss';

export class PdpRespPrintHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            LogoIcon: null,
        };
    }

    componentDidMount() {
        import(
            /* webpackChunkName: "PdpRespPrintHeaderLogo" */
            './PdpRespPrintHeaderLogo'
        ).then(({ PdpRespPrintHeaderLogo }) => {
            if (PdpRespPrintHeaderLogo) {
                this.setState({ LogoIcon: PdpRespPrintHeaderLogo });
            }
        });
    }

    render() {
        const { LogoIcon } = this.state;
        const { className, itemId, viewer } = this.props;

        return (
            <div className={`${styles.wrap} ${className}`}>
                {LogoIcon && <LogoIcon viewer={viewer} />}
                <p className={styles.itemId}>{itemId}</p>
            </div>
        );
    }
}

PdpRespPrintHeader.propTypes = {
    itemId: PropTypes.string.isRequired,
    className: PropTypes.string,
    viewer: PropTypes.object,
};
